import React, { FC } from 'react';
import { useLocation } from 'react-router-dom';

import { Toc, TocItem } from '@gravity-ui/uikit';
import { Link } from 'client/blocks/Link/Link';

export const SideMenu: FC<{ menuItems: TocItem[] }> = ({ menuItems }) => {
    const { pathname, hash } = useLocation();
    // Sub-items come in two flavours: hash-anchors (`path#section`) and real routes (`path`,
    // e.g. the integrations tab). Gluing a trailing '#' onto hash-less paths breaks equality
    // for the route flavour, so the hash is appended only when present.
    const activeValue = hash ? `${pathname}${hash}` : pathname;
    return (
        <Toc
            value={activeValue}
            items={menuItems.map((item) => ({
                value: item.value,
                content: (
                    <Link to={item.value} isCurrentPath={activeValue === item.value}>
                        {item.content}
                    </Link>
                ),
                items: item?.items
                    ? item.items.map((item) => ({
                          value: item.value,
                          content: (
                              <Link to={item.value} isCurrentPath={activeValue === item.value}>
                                  {item.content}
                              </Link>
                          ),
                      }))
                    : undefined,
            }))}
        />
    );
};
